export const CONNECTED = 'CONNECTED';

export const SET_MYSELF = 'SET_MYSELF';
export const SET_PLAYERS = 'SET_PLAYERS';
export const SET_COLOR = 'SET_COLOR';
